module.exports = __webpack_public_path__ + "static/media/bg_carpenter_didi.80649332.jpg";